export default __webpack_public_path__ + "static/media/logo.01ff1fbd.png";